<template>
    <input
        ref="input"
        type="text"
        step="0.01"
        v-model="formattedCurrencyValue"
        :class="className"
        :disabled="disabled"
        @blur="focusOut"
        @focus="focusIn"/>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: '0'
        },
        importe: {
            type: Number,
            default: 0
        },
        moneda: {
            type: String,
            default: '$'
        },
        readonly: {
            type: Boolean,
            default: false
        },
        cssClass: {
            type: String,
            default: ''
        }
    },  
    data() {
        return {
            currencyValue: 0,
            formattedCurrencyValue: "$ 0.00",
            disabled: false,
            className: ''
        }
    },
    mounted() {
        this.currencyValue = this.importe;
        this.formattedCurrencyValue = this.$options.filters.moneda(this.importe, this.moneda);
        this.disabled = this.readonly;
        this.className = this.cssClass;
    },
    methods: {
        focusOut() {
            // Recalculate the currencyValue after ignoring "$" and "," in user input
            this.currencyValue = parseFloat(this.formattedCurrencyValue.replace(/[^\d\.]/g, ""))

            // Ensure that it is not NaN. If so, initialize it to zero.
            // This happens if user provides a blank input or non-numeric input like "abc"
            if (isNaN(this.currencyValue)) {
                this.currencyValue = 0
            }

            this.formattedCurrencyValue = this.$options.filters.moneda(this.currencyValue, this.moneda);

            this.$emit('actualizarImporte', { 
                id: this.id, 
                importe: this.currencyValue });
        },
        focusIn(e) {
            // Unformat display value before user starts modifying it
            this.formattedCurrencyValue = this.currencyValue.toString();
            e.target.focus();
            e.target.setSelectionRange(0, this.formattedCurrencyValue.length);
        }
    },
    watch: {
        'importe' : function(newVal, oldVal) {
            if ( newVal != oldVal ) {
                this.currencyValue = this.importe;
                this.formattedCurrencyValue = this.$options.filters.moneda(this.importe, this.moneda);
            }
        },
        'readonly' : function(newVal, oldVal) {
            if ( newVal != oldVal ) {
                this.disabled = this.readonly;
            }
        },
    },    
}
</script>
